// extracted by mini-css-extract-plugin
export default {"instruction":"instruction--Txk3","links":"links--SPlE","icon":"icon--52NI","how-to":"how-to--aL65"};